export default "__VITE_ASSET__BBjlvQru__"